export var FETCH_DRAFT_ITEMS_REQUEST = 'FETCH_DRAFT_ITEMS_REQUEST';
export var FETCH_DRAFT_ITEMS_SUCCESS = 'FETCH_DRAFT_ITEMS_SUCCESS';
export var FETCH_DRAFT_ITEMS_ERROR = 'FETCH_DRAFT_ITEMS_ERROR';
export var FETCH_CART_ITEMS_REQUEST = 'FETCH_CART_ITEMS_REQUEST';
export var FETCH_CART_ITEMS_SUCCESS = 'FETCH_CART_ITEMS_SUCCESS';
export var FETCH_CART_ITEMS_ERROR = 'FETCH_CART_ITEMS_ERROR';
export var CREATE_CART_ITEM_REQUEST = 'CREATE_CART_ITEM_REQUEST';
export var CREATE_CART_ITEM_SUCCESS = 'CREATE_CART_ITEM_SUCCESS';
export var CREATE_CART_ITEM_ERROR = 'CREATE_CART_ITEM_ERROR';
export var FETCH_CART_ITEM_REQUEST = 'FETCH_CART_ITEM_REQUEST';
export var FETCH_CART_ITEM_SUCCESS = 'FETCH_CART_ITEM_SUCCESS';
export var FETCH_CART_ITEM_ERROR = 'FETCH_CART_ITEM_ERROR';
export var FETCH_SHIPPING_FEE_REQUEST = 'FETCH_SHIPPING_FEE_REQUEST';
export var FETCH_SHIPPING_FEE_SUCCESS = 'FETCH_SHIPPING_FEE_SUCCESS';
export var FETCH_SHIPPING_FEE_ERROR = 'FETCH_SHIPPING_FEE_ERROR';
export var DELETE_CART_ITEM_REQUEST = 'DELETE_CART_ITEM_REQUEST';
export var DELETE_CART_ITEM_SUCCESS = 'DELETE_CART_ITEM_SUCCESS';
export var DELETE_CART_ITEM_ERROR = 'DELETE_CART_ITEM_ERROR';
export var UPDATE_CART_ITEM_REQUEST = 'UPDATE_CART_ITEM_REQUEST';
export var UPDATE_CART_ITEM_SUCCESS = 'UPDATE_CART_ITEM_SUCCESS';
export var UPDATE_CART_ITEM_ERROR = 'UPDATE_CART_ITEM_ERROR';
export var UPDATE_CART_ITEM_QUANTITY_REQUEST = 'UPDATE_CART_ITEM_QUANTITY_REQUEST';
export var UPDATE_CART_ITEM_QUANTITY_SUCCESS = 'UPDATE_CART_ITEM_QUANTITY_SUCCESS';
export var UPDATE_CART_ITEM_QUANTITY_ERROR = 'UPDATE_CART_ITEM_QUANTITY_ERROR';
export var DELETE_COLLECTION_CART_ITEM = 'DELETE_COLLECTION_CART_ITEM';
export var REPLACE_CART_ITEM = 'REPLACE_CART_ITEM';
